'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { trackMenuToggle, trackNavClick } from '../../lib/analytics';

export default function Navigation() {
    const [isOpen, setIsOpen] = useState(false);
    const pathname = usePathname();

    // Close menu when route changes
    useEffect(() => {
        setIsOpen(false);
    }, [pathname]);

    // Prevent scrolling when menu is open
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
            // Also remove the inline style to be clean
            if (!document.body.getAttribute('style')) {
                document.body.removeAttribute('style');
            }
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isOpen]);

    return (
        <nav className="nav" aria-label="Ana Menü">
            <div className="nav-container">
                <Link href="/" className="nav-logo" aria-label="Victor Tomaili Ana Sayfa">
                    Victor<span>.</span>
                </Link>

                {/* Desktop Navigation */}
                <ul className="nav-links">
                    <li><Link href="/#hakkimda" onClick={() => trackNavClick('hakkimda')}>Hakkımda</Link></li>
                    <li><Link href="/#uzmanlik" onClick={() => trackNavClick('uzmanlik')}>Uzmanlık</Link></li>
                    <li><Link href="/#deneyim" onClick={() => trackNavClick('deneyim')}>Deneyim</Link></li>
                    <li><Link href="/danismanlik" onClick={() => trackNavClick('danismanlik')}>AI Danışmanlık</Link></li>
                    <li><Link href="/#iletisim" onClick={() => trackNavClick('iletisim')}>İletişim</Link></li>
                </ul>

                {/* Mobile Menu Button */}
                <button
                    className="mobile-menu-btn"
                    onClick={() => {
                        const newState = !isOpen;
                        setIsOpen(newState);
                        trackMenuToggle(newState ? 'open' : 'close');
                    }}
                    aria-label={isOpen ? "Menüyü Kapat" : "Menüyü Aç"}
                    aria-expanded={isOpen}
                >
                    <span className={`hamburger ${isOpen ? 'open' : ''}`}></span>
                </button>

                {/* Mobile Menu Overlay */}
                <div className={`mobile-menu ${isOpen ? 'open' : ''}`}>
                    <ul className="mobile-nav-links">
                        <li><Link href="/#hakkimda" onClick={() => { setIsOpen(false); trackNavClick('hakkimda'); }}>Hakkımda</Link></li>
                        <li><Link href="/#uzmanlik" onClick={() => { setIsOpen(false); trackNavClick('uzmanlik'); }}>Uzmanlık</Link></li>
                        <li><Link href="/#deneyim" onClick={() => { setIsOpen(false); trackNavClick('deneyim'); }}>Deneyim</Link></li>
                        <li><Link href="/danismanlik" onClick={() => { setIsOpen(false); trackNavClick('danismanlik'); }}>AI Danışmanlık</Link></li>
                        <li><Link href="/#iletisim" onClick={() => { setIsOpen(false); trackNavClick('iletisim'); }}>İletişim</Link></li>
                    </ul>
                </div>
            </div>
        </nav>
    );
}
